export default {
  notes: [],
  loading: false,
}
